const URL_STARTS_WITH_KEY = 'awz_exp_';
const SPLIT_CHARACTER = ',';
export const parseForceDecisionsFromUrlQuery = (params) => {
    const forceDecisions = [];
    Object.entries(params).forEach(([key, value]) => {
        const flagKey = key.substring(URL_STARTS_WITH_KEY.length);
        if (key.startsWith(URL_STARTS_WITH_KEY) &&
            flagKey.length > 0 &&
            value.toString().length > 0) {
            const [variationKey, ruleKey] = value.toString().split(SPLIT_CHARACTER);
            forceDecisions.push({
                flagKey,
                variationKey,
                ...(ruleKey && { ruleKey }),
            });
        }
    });
    return forceDecisions;
};
//# sourceMappingURL=parseForceDecisionsFromUrlQuery.js.map